module.exports = __webpack_public_path__ + "static/media/icons8-instagram.304fb315.svg";